import errorHandler from '@/mixins/errorHandler';
import { get } from '@/services/Axios';
import axios from 'axios';

export default {
  mixins: [errorHandler],
  data() {
    return {
      users: [],
      events: [],
      units: [],
      lahan: [],
      trendings: [],
      loadingUsers: false,
      loadingEvents: false,
      loadingLahan: false,
      loadingTrendings: false,
      loadingUnits: false
    };
  },
  methods: {
    async getUsers(...param) {
      this.loadingUsers = true;
      const parameter = param[0] || {};
      const params = {
        sort: parameter.sorts || 'account_name',
        dir: parameter.dir || 'ASC',
        filter: [
          {
            type: 'string',
            field: 'account_name',
            value: param.keyword || '',
            comparison: '<>'
          }
        ]
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results }
        } = await get('/monitoring/user-position', { params });
        this.users = results;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadingUsers = false;
      }
    },
    async getLahan(page) {
      this.loadingLahan = true;
      try {
        const { data } = await axios.get(
          'https://api-v2-monsta-mls.monsta.id/api/units',
          {
            params: {
              page
            },
            headers: {
              Authorization:
                'Bearer oat_NQ.LVRzS0hkVTg1OEZXZjh6d1A2S0R0N3hTQ0FKZU9WVnEyaEJERVc4cTE0NDY3NDM0MzA'
            }
          }
        );
        this.lahan = data;
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadingLahan = false;
      }
    },
    async getEvents(...param) {
      this.loadingEvents = true;
      const parameter = param[0] || {};
      const params = {
        sort: parameter.sorts || 'event_name',
        dir: parameter.dir || 'ASC',
        filter: [
          {
            type: 'string',
            field: 'event_name',
            value: param.keyword || '',
            comparison: '<>'
          }
        ]
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results }
        } = await get('/monitoring/event-position', { params });
        this.events = results;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadingEvents = false;
      }
    },
    async getUnits(...param) {
      this.loadingUnits = true;
      const parameter = param[0] || {};
      const params = {
        sort: parameter.sorts || 'unit_name',
        dir: parameter.dir || 'ASC',
        filter: [
          {
            type: 'string',
            field: 'unit_name',
            value: param.keyword || '',
            comparison: '<>'
          }
        ]
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results }
        } = await get('/monitoring/unit-position', { params });
        this.Units = results;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadingUnits = false;
      }
    },
    async getTrendings(...param) {
      this.loadingTrendings = true;
      const parameter = param[0] || {};
      const params = {
        sort: parameter.sorts || 'total',
        dir: parameter.dir || 'DESC',
        filter: []
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results }
        } = await get('/report/trending', { params });
        this.trendings = results;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadingTrendings = false;
      }
    }
  }
};
